import React from "react";

const Dostop = () => {
  return (
    <div className='dostop'>
      <div className='dostop-div'>
        {" "}
        <h1>DOSTOP DO SPLETNIH UČBENIKOV</h1>
      </div>

      <div className='prva-triada'>
        <h1>Prva triada</h1>

        <a href='https://www.lilibi.si/'>1. Lili in Bine</a>
      </div>
      <div className='druga-triada'>
        <h1>Druga triada</h1>
      </div>
      <div className='tretja-triada'>
        <h1>Tretja triada</h1>
      </div>
    </div>
  );
};

export default Dostop;
